export default __webpack_public_path__ + "static/media/scfoundation-2.b47711f7.webp";